import React from "react"
import gsap from "gsap"
//Context
import {
  useGlobalDispatchContext,
  useGlobalStateContext,
} from "../../context/globalContext"

const appearInfo = e => {
  const bubble = e.currentTarget.querySelector(".item-content .bubble")
  gsap.to(bubble, {
    duration: 0.8,
    y: "-70px",
    opacity: 1,
    ease: "power4.out",
  })
}

const disAppearInfo = e => {
  const bubble = e.currentTarget.querySelector(".item-content .bubble")
  gsap.to(bubble, {
    duration: 0.8,
    y: "-65px",
    opacity: 0,
    ease: "power4.out",
  })
}

const copyText = e => {
  const select = e.currentTarget.getAttribute("data-locate")
  const textArea = document.createElement("textarea")
  textArea.value = select
  document.body.appendChild(textArea)
  textArea.select()
  try {
    document.execCommand("copy")
  } catch (err) {
    console.log("Oops, unable to copy")
  }
  document.body.removeChild(textArea)
}

function LocateIcons({ dataLocate, locateText, Icon }) {
  const dispatch = useGlobalDispatchContext()
  const { cursorStyles } = useGlobalStateContext()

  const onCursor = (entry = "hover") => {
    const style = cursorStyles[`${entry}`].style
    dispatch({ type: "CURSOR_TYPE", payload: style })
  }
  return (
    <div
      role="presentation"
      className="locate-wrapper-item"
      onMouseEnter={e => {
        appearInfo(e)
        onCursor("pointer")
      }}
      onMouseLeave={e => {
        disAppearInfo(e)
        onCursor()
      }}
      onClick={copyText}
      data-locate={dataLocate}
    >
      <div className="item-envolt">
        <p className="item-content">
          <div className="bubble bubble-tab">{locateText.clip}</div>
          <Icon />
        </p>
      </div>
    </div>
  )
}

export default LocateIcons
